import "./ContactCard.scss";
export function ContactCard({ name, phone }) {
    const cleanPhone = phone.replace(/[^+\d]/g, "");
    return (
        <div className="contact-card" role="group" aria-label={`${name} contact`}>
            <div className="contact-name"><strong>{name}</strong></div>
            <div className="contact-phone-wrap">
                <a className="contact-phone" href={`tel:${cleanPhone}`} aria-label={`Call ${name}`}>
                    {phone}
                </a>
            </div>
        </div>
    );
}